import { atom, useAtomValue, useSetAtom } from 'jotai';
import { BaseImage, SanityKeyed, SanityBlock } from 'types/studio/studio';

type CurrentBabProduct = {
  description?: Array<SanityKeyed<SanityBlock>>;
  productTitle?: string;
  imageMobile?: BaseImage;
};

export const currentBabProductAtom = atom<CurrentBabProduct | null>(null);

export function useSetCurrentBabProductAtom() {
  return useSetAtom(currentBabProductAtom);
}

export function useAtomValueCurrentBabProductAtom() {
  let babProduct = useAtomValue(currentBabProductAtom);

  try {
    if (!babProduct) {
      babProduct = JSON.parse(localStorage.getItem('babProduct') || '{}');
    } else {
      localStorage.setItem('babProduct', JSON.stringify(babProduct || '{}'));
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }

  return babProduct;
}
